import TaskFilters from "../../interfaces/task/TaskFilters";

export function appendTeamFilterParams(
  queryParams: URLSearchParams,
  filters?: TaskFilters | null,
): void {
  filters?.teamIds?.forEach((teamId) => {
    if (Number.isInteger(teamId) && teamId > 0) {
      queryParams.append("team", teamId.toString());
    }
  });
}
